import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteExternalEmbedWidgetFragment } from 'bundles/ent-website/queries/EntWebsiteExternalEmbedWidget';
import { entWebsitePartnerFragment } from 'bundles/ent-website/queries/EntWebsitePartnerList';
import { entWebsiteTestimonialFragment } from 'bundles/ent-website/queries/EntWebsiteTestimonial';
import { ctaFragment, imageFragment, promoCodeConfigFragment, videoFragment } from 'bundles/ent-website/queries/common';

export const entWebsiteProofPointFragment = contentfulGql`#graphql
  fragment EntWebsiteProofPoint on EntWebsiteProofPoint {
    title
    slug
    keyMetric
    unit
    description
    footnote
  }
`;

export const entWebsiteContentColumnLink = contentfulGql`#graphql
  fragment EntWebsiteContentColumnLinks on EntWebsiteContentColumnBodyLinks {
    entries {
      block {
        __typename
        sys {
          id
        }

        ... on EntWebsiteRichText {
          color
          body {
            json
          }
        }
      }
    }
  }
`;

export const entWebsiteContentColumnFragment = contentfulGql`#graphql
  ${imageFragment}
  ${ctaFragment}
  ${entWebsiteContentColumnLink}
  fragment EntWebsiteContentColumn on EntWebsiteContentColumn {
    sys {
      id
    }
    title
    titleFontSize
    titleFontWeight
    titleColor
    eyebrow
    eyebrowFontSize
    eyebrowFontWeight
    eyebrowColor
    body {
      json
      links {
        ...EntWebsiteContentColumnLinks
      }
    }
    bodyColor
    icon {
      ...Image
    }
    cta {
      ...Cta
    }
    ctaVariant
    ctaPosition
    ctaFullWidth
    columnSpan
    backgroundColor
    borderRadius
    padding
    height
  }
`;

export const entWebsiteHowFragment = contentfulGql`#graphql
  ${imageFragment}
  ${videoFragment}
  ${entWebsitePartnerFragment}
  ${entWebsiteTestimonialFragment}
  ${entWebsiteProofPointFragment}
  ${ctaFragment}
  ${entWebsiteExternalEmbedWidgetFragment}
  ${entWebsiteContentColumnFragment}
  ${promoCodeConfigFragment}
  fragment EntWebsiteHow on EntWebsiteHow {
    slug
    headline
    description
    promoCodeConfigsCollection {
      items {
        ...PromoCodeConfig
      }
    }
    howDetailsCollection(limit: 6) {
      items {
        slug
        headline
        description
        proofPointCollection(limit: 1) {
          items {
            ...EntWebsiteProofPoint
          }
        }
      }
    }
    howDetailsDisplayStyle
    associatedPartnersCollection(limit: 9) {
      items {
        ...EntWebsitePartner
      }
    }

    testimonialCollection(limit: 3) {
      items {
        ...EntWebsiteTestimonial
      }
    }

    secondaryCtAsCollection(limit: 3) {
      items {
        ...Cta
      }
    }

    image {
      ...Image
    }

    video {
      ...Video
    }

    ceros {
      ...EntWebsiteCerosWidget
    }

    ctaText
    ctaTarget
    subCtaText {
      json
    }
    subCtaTextMarkdown

    proofPointsCollection {
      items {
        ...EntWebsiteProofPoint
      }
    }

    proofPointsModuleHeading
    proofPointsModuleSubheading
    proofPointsModuleBackgroundColor
    proofPointsModuleFontColor
    proofPointsModuleCta {
      ...Cta
    }
    proofPointsModuleCtaButtonVariant
    proofPointsDisplayStyle
    expandedContentColumnsCollection {
      items {
        ...EntWebsiteContentColumn
      }
    }
    expandedContentColumnsGridGap
  }
`;

export const entWebsiteBlockHowQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteHowFragment}
  query entWebsiteBlockHow($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteHow
      }
    }
  }
`;
